import { ValueService } from '../services/ValueService.js';

/**
 * @typedef {import('../types/message.d.js').MessageType} MessageType
 * @typedef {import('../types/message.d.js').Message} Message
 */

class MessageStoreClass {
    #list = $state([]);
    #timers = new Map();

    get list() {
        return this.#list;
    }

    /**
     * @param {MessageType} type
     * @param {string} text
     * @param {number} timeout
     */
    add(type, text, timeout) {
        const id = crypto.randomUUID();

        const message = {
            id,
            type,
            text: ValueService.toStringSingleLine(text),
            visible: true,
        };

        this.#list = [...this.#list, message];
        if (this.#list.length > 10) {
            this.#list = this.#list.slice(-10);
        }

        const timer = setTimeout(
            () => {
                this.remove(id);
            },
            ValueService.toUInt(timeout, 5000)
        );

        this.#timers.set(id, timer);
    }

    /**
     * @param {string} id
     */
    remove(id) {
        const timer = this.#timers.get(id);

        if (timer) {
            clearTimeout(timer);
            this.#timers.delete(id);
        }

        this.#list = this.#list.filter((m) => m.id !== id);
    }

    /**
     * @param {string} message
     * @param {number} [timeout]
     */
    info(message, timeout = 5000) {
        this.add('info', message, timeout);
    }

    /**
     * @param {string} message
     * @param {number} [timeout]
     */
    success(message, timeout = 5000) {
        this.add('success', message, timeout);
    }

    /**
     * @param {string} message
     * @param {number} [timeout]
     */
    warning(message, timeout = 10000) {
        this.add('warning', message, timeout);
    }

    /**
     * @param {string} message
     * @param {number} [timeout]
     */
    error(message, timeout = 20000) {
        this.add('error', message, timeout);
    }
}

export const MessageStore = new MessageStoreClass();
